import { PHONE, locationSchema } from "../structured-data-core";

export function getColoradoSpringsStructuredData() {
  const url = "https://restorehair.com/locations/colorado/colorado-springs/";
  const description =
    "Find out about your hair transplant options in Colorado Springs with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Colorado Springs", "102 S Tejon St", "Colorado Springs", "CO", PHONE, url, description),
  ];
}
